import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

function StylishMapSection() {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Days of the week
  const days = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

 const isRTL = i18n.dir() === "rtl";
  const fontFamily = isRTL
    ? "'Tajawal', Arial, sans-serif"
    : "Arial, Helvetica, sans-serif";



  return (
    <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden', mb: 10 }}>
      
      {/* Google Map */}
      <Box
        sx={{
          width: '100%',
          height: isMobile ? '800px' : '500px',
        }}
      >
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3626.221053424098!2d46.70400997536436!3d24.650518378066998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDM5JzAxLjkiTiA0NsKwNDInMjMuNyJF!5e0!3m2!1sen!2ssa!4v1747221412797!5m2!1sen!2ssa"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Box>

      {/* Overlay Card */}
      <Box
        sx={{
          position: 'absolute',
          top: isMobile ? '40px' : '120px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: isMobile ? '92%' : '85%',
          bgcolor: 'rgba(255,255,255,0.95)',
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.77)',
          borderRadius: 4,
          backdropFilter: 'blur(8px)',
          px: { xs: 2, sm: 3 },
          py: { xs: 3, sm: 4 },
          direction: i18n.dir(), // RTL support
        }}
      >
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          fontFamily={fontFamily}
          sx={{
            fontWeight: 700,
            color: '#0C2182',
            textAlign: 'center',
            mb: { xs: 2.5, sm: 3 },
          }}
        >
          {i18n.language === 'ar' ? 'ساعات العمل' : 'Opening Hours'}
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {days.map((dayKey) => (
            <Grid
              item
              key={dayKey}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              sx={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Paper
                elevation={3}
                sx={{
                  width: '100%',
                  maxWidth: 260,
                  textAlign: 'center',
                  p: { xs: 1.5, sm: 2 },
                  borderRadius: 2,
                  backgroundColor: '#f7f8ff',
                  transition: '0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                  },
                }}
              >
                <Typography
                  fontFamily={fontFamily}
                  sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: '15px', sm: '16px' },
                    color: '#0C2182',
                    mb: 0.5,
                  }}
                >
                  {t(`${dayKey}.day`)}
                </Typography>
                <Typography
                  fontFamily={fontFamily}
                  sx={{
                    fontSize: { xs: '13px', sm: '14px' },
                    color: '#444',
                  }}
                >
                  {t(`${dayKey}.hours`)}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default StylishMapSection;
